import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApsServiceService } from '../aps-service.service';

@Component({
  selector: 'app-eventsdetails',
  templateUrl: './eventsdetails.component.html',
  styleUrls: ['./eventsdetails.component.css']
})
export class EventsdetailsComponent implements OnInit {
  loaderdata:any=false
  dataexist:any=false
  data:any=''
  eventdetails:any;
  pages:any=''
  next:any=''
  previous:any=''
  first:any=""
  last:any=""
  limit:any=4
  eventspage:any='';
  eventid:any

  constructor(private route: ActivatedRoute,private searchitem: ApsServiceService,private sanitizer:DomSanitizer) { }

  ngOnInit(): void {
   
    this.geturldatas()

  }
geturldatas(){
  this.data=''
  this.loaderdata=true
  this.eventid = this.route.snapshot.params.eventid;
  //console.log(this.eventid)
  //console.log(this.route.snapshot.params.eventname)
  this.eventspage=this.route.snapshot.params.eventname
  this.searchitem.geteventdetails(this.eventid).subscribe((responce) => {
    if(responce.status){
      //console.log(responce)
      this.data=responce.data
      this.eventdetails= this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details)
      this.loaderdata=false

 
}else{
  this.dataexist=false

}
// this.loaderdata=false
  })
}

}
